// Module-level store for the Cognito ID token.
// Pre-initialized from localStorage so API calls on first render have a token
// before AuthGate's useEffect fires.
import { COGNITO, oidcStorageKey } from '@shared/lib/constants';

function _loadFromStorage(): string | null {
  try {
    const raw = localStorage.getItem(oidcStorageKey(COGNITO.userClientId));
    return raw ? (JSON.parse(raw)?.id_token ?? null) : null;
  } catch { return null; }
}

let _idToken: string | null = _loadFromStorage();
let _signingOut = false;

export function setSigningOut(v: boolean): void { _signingOut = v; }
export function isSigningOut(): boolean { return _signingOut; }

export function setAuthToken(token: string): void {
  _idToken = token;
}

export function getAuthToken(): string | null {
  return _idToken;
}

export function authHeaders(): Record<string, string> {
  return _idToken ? { Authorization: `Bearer ${_idToken}` } : {};
}
